<script setup lang="ts">
import type { AppCircleCheckboxTheme } from './AppCircleCheckbox.model';
import Checked from './Checked.vue';
import Unchecked from './Unchecked.vue';

interface AppCircleCheckboxProps {
  checked: boolean;
  theme: AppCircleCheckboxTheme;
}

const props = defineProps<AppCircleCheckboxProps>();

interface AppCircleCheckboxEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<AppCircleCheckboxEmits>();
</script>

<template>
  <div class="app-circle-checkbox" @click="emit('click')">
    <Checked
      v-if="props.checked"
      :checked="props.checked"
      :theme="props.theme"
    />
    <Unchecked :theme="props.theme" v-else />
  </div>
</template>
